import type { AxiosResponse } from "axios";
import { BASE_URL, httpClient } from "../config/develop-config";
export const authUrl = `${BASE_URL}/auth`;

export const getSoApproveByComp = async (company: string) => {
  return await httpClient
    .get(`${authUrl}/so-approver/approvers/${company}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
export const deleteGroup = async (id: string, updateBy: string) => {
  return await httpClient
    .delete(`${authUrl}/so-approver/group/${id}/${updateBy}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
export const updateSoApprove = async (data: object) => {
  return await httpClient
    .post(`${authUrl}/so-approver/update`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
export const createSoApprove = async (data: object) => {
  return await httpClient
    .post(`${authUrl}/so-approver/create-group`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
